import script from "./TireDetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TireDetailsModal.vue?vue&type=script&setup=true&lang=ts"

import "./TireDetailsModal.vue?vue&type=style&index=0&id=258d22b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-258d22b7"]])

export default __exports__